export const makeParkingPaymentStyles = {
	header: {
		backgroundColor: '#8D99AE',
	},
	sidebar: {
		backgroundColor: '#D90429',
		color: 'white',
	},
	title: {
		color: '#FFFFFF',
	},
	button: {
		backgroundColor: '#D90429',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#d47081ff',
		},
	},
	text: {
		color: '#000000ff',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#D90429',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Make Parking Payment',
	},
	logo: {
		small: {
			src: '/makeParkingPayment/mpp-icon-red.svg',
			height: 35,
			width: 35,
		},
		large: {
			src: '/makeParkingPayment/mpp-icon-red.svg',
			height: 56,
			width: 150,
		},
	},
	favicon: {
		src: '/makeParkingPayment/mpp-icon-red.svg',
	},
	socials: {},
	siteUrl: 'https://makeparkingpayment.com/',
	orgName: 'Make Parking Payment',
};
